import {navigate} from '../../../../../utils/navigation';

export default () => {
    return (
        <div className="col vip" onClick={e => navigate('/vip')}>
            <div className="content">
                <div className="info">
                    <div className="title">VIP Club</div>
                    <div className="text">Unlock better rewards as you level up your VIP status.</div>
                </div>

                <div className="link">
                    Progress

                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M8.41797 3.45898L11.9588 6.99982L8.41797 10.5407" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.04199 7H11.8595" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="background">
                <div className="vip-bg"></div>
            </div>
        </div>
    )
}